<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="name"
                >Company Name (in full)
                <span class="invalid" v-if="errors.name">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="name"
                v-model="company.name"
                placeholder="Company Name"
                class="form-control"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="industry"
                >Industry
                <span class="invalid" v-if="errors.industry">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="industry"
                v-model="company.industry"
                placeholder="Industry"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="companyEmail"
                >Company Email
                <span class="invalid" v-if="errors.companyEmail">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="companyEmail"
                v-model="company.companyEmail"
                placeholder="Company Email"
                class="form-control"
              />
              <div
                :class="`${validEmail ? `d-none` : `d-block`} invalid-feedback`"
              >
                Please provide a valid email
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="phone"
                >Contact Number
                <span class="invalid" v-if="errors.phone">
                  - Input a valid contact number</span
                >
              </label>
              <input
                type="text"
                name="phone"
                v-model="company.phone"
                placeholder="Contact number"
                :class="`form-control`"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="eventName">Company Logo or Photo</label>
              <div class="row">
                <div class="col-9">
                  <input
                    type="text"
                    name="featuredImage"
                    v-model="company.image"
                    class="form-control"
                    disabled
                  />
                </div>
                <div class="col-3">
                  <ActionButton
                    :theme="{ primary, secondary, danger, event }"
                    @customEvent="handleShowMediaGallery"
                    label="Media Gallery"
                    style="width: auto; margin-top: 0; margin-left: auto;"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="address"
                >Address
                <span class="invalid" v-if="errors.address">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="address"
                v-model="company.address"
                placeholder="Address"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="officeType"
                >Office Type
                <span class="invalid" v-if="errors.category">
                  - Field is required</span
                >
              </label>
              <v-select
                @input="handleChangeBaseSelects"
                :options="collections.offices"
                v-model="company.category"
                name="officeType"
              />
            </div>
          </div>
          <div class="col" v-if="!editCompany">
            <div class="form-group">
              <label for="location"
                >Location
                <span class="invalid" v-if="errors.location">
                  - Field is required</span
                >
              </label>
              <v-select
                @input="handleChangeBaseSelects"
                :options="collections.locations"
                v-model="company.location"
                name="location"
              />
            </div>
          </div>
        </div>
        <template v-if="!editCompany">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="product"
                  >Assigned Space
                  <span class="invalid" v-if="errors.product">
                    - Field is required</span
                  >
                </label>
                <v-select
                  @input="handleChangeProduct"
                  :options="collections.products"
                  v-model="company.product"
                  name="product"
                >
                  <template slot="no-options">
                    <span>Select Office Type and Location</span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="product"
                  >Package / Term / Contract
                  <span class="invalid" v-if="errors.package">
                    - Field is required</span
                  >
                </label>
                <v-select
                  :options="collections.packages"
                  v-model="company.package"
                  name="package"
                >
                  <template slot="no-options">
                    <span v-if="collections.packages.length > 0">
                      select a Product first
                    </span>
                    <span v-else>No available packages for this product</span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="product"
                  >Owner
                  <span class="invalid" v-if="errors.owner">
                    - Field is required</span
                  >
                </label>
                <v-select
                  :options="collections.users"
                  v-model="company.owner"
                  name="owner"
                >
                  <template slot="no-options">
                    type to search from members list
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="address">Description</label>
              <textarea
                name="description"
                v-model="company.description"
                rows="5"
                class="form-control form-control-sm"
                placeholder="Brief company description"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                :label="btnLabel"
                :theme="{ primary, secondary, event, danger }"
                :type="'button'"
                @customEvent="createCompany()"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <MediaGalleryModal
      v-if="showMediaGallery"
      @response="handleResponseGallery"
      @close="handleCloseGallery"
    />
  </div>
</template>

<script>
import MediaGalleryModal from "@/components/media-gallery/MediaGalleryModal";
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/axios";
import _ from "lodash";
import { socketSender } from "@/helpers/socket";
import * as logger from "@/helpers/logger";

export default {
  name: "AddNewCompany",
  components: {
    ActionButton,
    MediaGalleryModal
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      btnLabel: "Create",
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      toastrOptions: {
        positionClass: "toast-bottom-center"
      },
      selectedUserRole: "Member",
      collections: {
        users: [],
        offices: [],
        locations: [],
        products: [],
        packages: []
      },
      editCompany: false,
      isToggled: false,
      showMediaGallery: false,
      // DATA
      company: {},
      errors: {},
      validEmail: true,
      required: [
        "name",
        "industry",
        "companyEmail",
        "phone",
        "address",
        "category",
        "location",
        "product",
        "package",
        "owner"
      ]
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    const requests = [
      {
        options: {
          model: "locations",
          variable: "locations"
        },
        labels: ["name"]
      },
      {
        options: {
          model: "users",
          variable: "users"
        },
        labels: ["firstName", "lastName"]
      },
      {
        options: {
          model: "categories",
          variable: "offices",
          extension: "type=1"
        },
        labels: ["name"]
      }
    ];
    this.fetch(requests);
    this.handleEditCompany();
  },
  methods: {
    handleChangeBaseSelects() {
      this.collections.products = [];
      this.collections.packages = [];
      delete this.company.product;
      delete this.company.package;
      this.fetchProduct();
    },
    handleChangeProduct() {
      this.collections.packages = [];
      delete this.company.package;
      if (this.company.product) {
        const options = {
          model: "packages",
          variable: "packages",
          extension: `productId=${this.company.product.value}`
        };
        this.fetchPaginatedModel(options, ["Term"]);
      }
    },

    handleShowMediaGallery() {
      this.showMediaGallery = true;
      this.$emit("toggleScroll", { scroll: false });
    },
    handleResponseGallery(obj) {
      this.company.image = obj.original;
    },
    handleCloseGallery() {
      this.showMediaGallery = false;
      this.$emit("toggleScroll", { scroll: true });
    },
    handleTogglePasswordClick() {
      this.isToggled = !this.isToggled;
    },
    fetch(requests) {
      for (const request of requests) {
        this.fetchPaginatedModel(request.options, request.labels);
      }
    },
    fetchProduct() {
      this.products = [];
      const { category, location } = this.company;
      if (category && location) {
        const options = {
          model: "products",
          variable: "products",
          extension: `categoryId=${category.value}&locationId=${location.value}`
        };
        this.fetchPaginatedModel(options, ["name"]);
      }
    },
    fetchPaginatedModel(
      { model, page = 1, size = 10, variable, extension },
      labels
    ) {
      var link = `/${model}?page[number]=${page}&page[size]=${size}`;
      if (extension) {
        link += `&${extension}`;
      }
      axios.get(link).then(response => {
        const { data, meta } = response.data;
        this.collections[variable] = [
          ...this.collections[variable],
          ...data.map(value => ({
            label: labels
              .map(label => {
                if (label === "Term") {
                  return value.Term.name;
                } else {
                  return value[label];
                }
              })
              .join(" "),
            value: value.id
          }))
        ];

        if (meta.hasNextPage) {
          const paginated = {
            model: model,
            page: page + 1,
            size: size,
            status: status,
            variable: variable
          };
          this.fetchPaginatedModel(paginated, labels);
        }
        this.collections[variable] = _.uniqBy(
          this.collections[variable],
          data => data.value
        );
      });
    },
    isRequired(key) {
      if (this.company[key]) {
        return true;
      }
      return false;
    },
    fetchCompanies(from) {
      if (from.meta.officeType) {
        axios
          .get(`/categories?name=${from.meta.officeType}`)
          .then(response => {
            const { data: offices } = response.data;
            const officeType = {
              label: from.meta.officeType,
              value: offices.length > 0 ? offices[0].id : null
            };
            this.$store.dispatch("fetchCompanies", {
              officeType: officeType
            });
            this.$emit("close");
          })
          .catch(err => logger.error(err));
      } else {
        this.$store.dispatch("fetchCompanies", {});
        this.$emit("close");
      }
    },
    handleEmitClose() {
      this.fetchCompanies(this.$route);
    },
    handleEditCompany() {
      var company = this.singleRecord;
      if (company) {
        company = JSON.parse(JSON.stringify(company));
        var category = null;
        if (company.Category) {
          category = {
            label: company.Category.name,
            value: company.Category.id
          };
        }
        this.company = company;
        this.company.category = category;
        this.editCompany = true;
        this.btnLabel = "Update";
      }
    },
    async createCompany() {
      let isValid = true;
      this.errors = {};
      const ignore = ["location", "product", "package", "owner"];
      for (const key of this.required) {
        if (!this.isRequired(key)) {
          if (!this.isPhone(this.company["phone"])) {
            this.errors["phone"] = true;
            isValid = false;
          }
          if (!(ignore.includes(key) && this.editCompany)) {
            this.errors[key] = true;
            isValid = false;
          }
        }
      }
      if (
        !this.company.companyEmail.includes("@") ||
        !this.company.companyEmail.includes(".com")
      ) {
        isValid = false;
        this.errors.email = true;
        this.validEmail = false;
      }

      if (isValid) {
        let email = this.company.companyEmail.trim();
        let checkCompany = await axios.get(
          `/groups?companyEmail=${email}&paranoid=false`
        );
        /**
         * Company email validation
         */
        if (checkCompany.data.data.length > 0 && !this.editCompany) {
          /**
           * Insert new company
           */
          this.$toastr.warning("Company Email is already used", "Warning");
          return;
        }
        /**
         * Update existing company
         */
        if (
          this.editCompany &&
          checkCompany.data.data.length != 0 &&
          this.company.id != checkCompany.data.data[0].id
        ) {
          this.$toastr.warning("Company Email is already used", "Warning");
          return;
        }

        this.company.categoryId = this.company.category.value;
        if (!this.editCompany) {
          /**
           * SOCKET: Add new company
           */
          let logContent = `${this.$store.getters.getFullUser} added a new Company named ${this.company.name} owned by ${this.company.owner.label} on ${this.company.category.label} - ${this.company.product.label}`;

          socketSender("updateLog", logContent);
          // Create new company
          this.company.CompanyUsers = [{ userId: this.company.owner.value }];
          axios
            .post("/groups", this.company)
            .then(response => {
              const { id } = response.data.data;
              const meta = [
                {
                  userId: this.company.owner.value,
                  key: `owner:company-${id}`,
                  value: "Owner",
                  label: "CEO"
                }
              ];
              axios
                .post(`/users/${this.company.owner.value}/meta`, meta)
                .then(() => {
                  this.$toastr.success("New company has been added", "Success");
                  this.handleEmitClose();
                })
                .catch(error => {
                  logger.error(error);
                  this.handleEmitClose();
                });
            })
            .catch(error => {
              logger.error(error);
              this.handleEmitClose();
            });
        } else {
          // Update existing company
          axios
            .patch(`/companies/${this.company.id}`, this.company)
            .then(() => {
              this.$toastr.success("Company has been updated", "Success");
              this.handleEmitClose();
            })
            .catch(error => {
              logger.error(error);
              this.handleEmitClose();
            });
        }
      } else {
        this.$toastr.warning("Please fill the required fields", "Warning");
      }
    },
    isPhone(num) {
      return /^(?=.*[0-9])[- +()0-9]+$/.test(num);
    }
  }
};
</script>

<style lang="scss">
.invalid {
  color: red;
}
.form-group {
  .password-wrapper {
    position: relative;
    img {
      cursor: pointer;
      position: absolute;
      right: 0.75em;
      top: 11px;
      transition: all 0.2s ease;
      &:hover,
      &.is-visible {
        filter: brightness(50%);
      }
    }
  }
  textarea {
    font-weight: 200;
    font-size: $font-size-xs;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
  }
  ul {
    font-size: $font-size-xs;
  }
}
</style>
